import React from 'react';
import { Button } from '@activehub/common-components-spa-resource';
import { useHistory } from 'react-router-dom';
import { Footer } from '../footer/Footer';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const PreLoginMobile = ({ footerLinks, setClient, isMobile }) => {
    const history = useHistory();
    const smallScreen = useMediaQuery('(min-width:400px)');
    return (
        <div className='prelogin-mobile'>
            <div className="activehub-logo-container">
                {/* <img
                    src={`${process.env.PUBLIC_URL}/images/Growth_buds_Growth_buds.png`}
                    alt="logo"
                    className="activehub-logo tablet"
                />
                <img
                    src={`${process.env.PUBLIC_URL}/images/Growth_buds_Growth_buds_mobile.png`}
                    alt="logo"
                    className="activehub-logo mobile"
                /> */}
            </div>
            <div className="activehub-text">
                <img src={`${process.env.PUBLIC_URL}/images/${smallScreen ? 'pearson-desktop-logo.svg' : 'pearson-mobile-logo.svg'}`} alt="logo" className="pearson-logo" />
                <div className="creation__logo">ActiveHub</div>
                <div className="creation__insights">Pinpoint where students are.</div>
                <div className="creation__insights">Then take them further.</div>
            </div>
            <div className='signin-container'>
                <div className="w-auto center-items">
                    <Button
                        useButtonClass={false}
                        ariaDescribedby={"sign in"}
                        onClick={setClient}
                        id="ALSecondary"
                        className={`sign-in`} >
                        <span className='sign-in-text'>Sign in</span>
                    </Button>
                </div>
                <div className='horizontal-line'>
                    <div className='line'></div>
                    <div>or</div>
                    <div className='line'></div>
                </div>
                <div className="w-auto center-items">
                <Button
                    useButtonClass={false}
                    ariaDescribedby={"RegisterAccessCode"}
                    onClick={()=>{history.push(`/access-code-registration`)}}
                    className={`register-access-code`}>
                    <span className='register-text'>Register with an access code</span>
                </Button>
                </div>
                <div className="links-container center-items">
                    <span className='links mr-link'><a rel='noreferrer' target="_blank" href='https://www.pearsonschoolsandfecolleges.co.uk/activehub'>Find out more</a></span>
                    <span className='links'><a rel='noreferrer' href='https://support.pearson.com/uk/s/digital-contactus' target="_blank">Contact us</a></span>
                </div>
                {/* {isMobile && <div className="grey-line"></div>}
                <div className='p-2 mr-2 mt-5'>
                    <div className='updates mb-3'>
                        Latest Updates
                    </div>
                    <div className="gsamblk">
                        <div className="gsamblk__txt-wrp">
                            <div className='update-heading'>
                                New Science online activities
                            </div>
                            <div className='gsamblk__txt-wrp_txt'>
                                You can now assign our new combined science activities with more interactive questions and examples that will help your students understand blah blah blah blah blah blah blah.
                            </div>
                            <div className='learn-more'>
                                <span className='mr-2'>New Science online activities</span>
                                <span>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/learn-more.svg`}
                                        alt="logo"
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
            <div role="contentinfo" className="gwWraper_footer">
                <Footer footerLinks={footerLinks || []} />
            </div>
        </div>
    )
}

export default PreLoginMobile;